import type { ReactNode } from 'react';

import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

export const ExternalModalLayout = ({ children, className }: Props) => (
  <div
    className={classNames(
      'vai-relative vai-w-full vai-h-full vai-p-6 vai-bg-white vai-overflow-y-auto',
      className,
    )}
  >
    {children}
  </div>
);
